import React from 'react'

const Notyet = () => {
  return (
    <div className='container-fluid d-flex align-items-center justify-content-center'>
        <h1>No History Yet!!</h1>
    </div>
  )
}

export default Notyet